import React, { Component } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { Toast } from 'antd-mobile';
import AuthCode from '../common/InviteAuthCode';
import ImageAuth from '../../components/Popup/ImageAuth';
import Http from '../../config/axiosUtils';
import {withRouter} from "react-router-dom";
import { validateTel, replaceNumber, validateAuthcode } from '../../utils/validate';
import './InviteLoginCommon.scss';


class InviteLogin extends Component {
  state = {
    mobile: queryString.parse(this.props.location.search)?.mobile ==='null' ? '' : queryString.parse(this.props.location.search)?.mobile || '',
    authCode: '',
    mobileClose: false, //手机号关闭按钮
    anthCodeClose: false, //验证码关闭按钮
    isSend: false, //是否可以获取验证码
    hasSend: false, //是否已经获取验证码
    isShowImageCode: false,
    regNum: /[^0-9]/g, //数字正则
  }

  //监听输入框变化和聚焦
  handelInput = (key, maxLength, event) => {
    const str = replaceNumber(event.target.value, maxLength);
    this.setState({
      [key]: str,
      mobileClose: key === 'mobile' && str,
      anthCodeClose: key === 'authCode' && str,
      isSend: false,
    })
  }

  //清空输入框
  deleteInput = (key) => {
    this.setState({
      [key]: '',
      mobileClose: !key === 'mobile',
      anthCodeClose: !key === 'authCode',
      isSend: false
    })
  }

  //判断手机号是否合法
  onHandlePhone = () => {
    if (!validateTel(this.state.mobile)) {
      Toast.info('请输入正确的手机号码！', 2);
      return;
    }
    this.sendAuthCode();
  }

  //发送验证码
  sendAuthCode = (obj) => {
    Toast.loading('发送中，请稍后...', 0.5, async () => {
      const path = '/spread/web/authCode/send';
      const postData = {
        mobile: this.state.mobile,
        type: this.props.type,
      }
      if (obj) {
        postData.requestId = obj.requestId;
        postData.validationCode = obj.validationCode;
      }
      const res = await Http.post(path, postData);
      if (res.code === 0) {
        Toast.hide();
        this.setState({
          isSend: true,
          isShowImageCode: false
        })
      } else if (res.code === 1001) {
        Toast.hide();
        this.setState({
          isShowImageCode: true
        })
      } else if (res.code === 1002) {
        Toast.fail(res.msg, 2);
        this.ImageAuth.clearImg();
      } else {
        Toast.fail(res.msg, 2);
        let that = this;
        Toast.fail(res.msg,2,function () {
          that.props.history.replace('/login');
        })
      }
    });
  }

  //验证码发送成功回调
  onSuccessSend = () => {
    this.setState({
      hasSend: true,
      isSend: false
    });
  }

  next = () => {
    if (!validateTel(this.state.mobile)) {
      Toast.info('请输入正确的手机号码！', 2);
      return;
    }
    if (!this.state.hasSend) {
      Toast.info('请先获取验证码！', 2);
      return;
    }
    if (!validateAuthcode(this.state.authCode)) {
      Toast.info('请输入正确的验证码！', 2);
      return;
    }
    this.nextStep();
  }

  nextStep = () => {
    Toast.loading('loading...', 0.5, async () => {
      const path = this.props.type === 10 ? '/spread/web/authCode/simpleCheck' : '/spread/web/user/login';
      const postData = {
        mobile: this.state.mobile,
        authCode: this.state.authCode
      }
      if (this.props.type === 10) {
        postData.type = 10;
      }
      const res = await Http.post(path, postData);
      if (res.code === 0) {
        Toast.hide();
        this.props.nextFunc(this.props.type === 10 ? postData : res.data);
      } else {
        this.setState({
          authCode: ''
        });
        Toast.fail(res.msg, 2);
      }
    });
  }

  keyupEvent = (key, event) => {
    this.setState({
      [key]: event.target.value.replace(this.state.regNum, '')
    })
  }

  render () {
    let { mobile, authCode, mobileClose, anthCodeClose, isSend } = this.state;
    return (
      <div className='login'>
        <div className='login-header'>
        </div>
        <div className='login-mid'>
          <section className='mobile-container'>
            <input type="tel"
                   placeholder="请输入手机号"
                   name="phone"
                   maxLength="11"
                   value={mobile}
                   onFocus={this.handelInput.bind(this, 'mobile', 11)}
                   onChange={this.handelInput.bind(this, 'mobile', 11)}
                   onKeyUp={this.keyupEvent.bind(this, 'mobile')} />
            {mobileClose && <i className='iconfont icon-delete' onClick={this.deleteInput.bind(this, 'mobile')}></i>}
          </section>
          <section className='auth-container'>
            <input type="tel"
                   placeholder="请输入验证码"
                   name="authCode"
                   maxLength="6"
                   value={authCode}
                   onFocus={this.handelInput.bind(this, 'authCode', 6)}
                   onChange={this.handelInput.bind(this, 'authCode', 6)}
                   onKeyUp={this.keyupEvent.bind(this, 'authCode')} />
            {anthCodeClose && <i className='iconfont icon-delete' onClick={this.deleteInput.bind(this, 'authCode')}></i>}
            <AuthCode isSend={isSend} isHighColor={Boolean(mobile)} onHandlePhone={this.onHandlePhone} onSuccessSend={this.onSuccessSend}></AuthCode>
          </section>
          <div className={`login-btn ${mobile && authCode && 'login_high'}`} onClick={mobile && authCode ? this.next : () => {return;}}>{this.props.btnTitle}</div>
          {this.state.isShowImageCode && <ImageAuth imgSuccess={this.sendAuthCode} closeImgAuth={() => this.setState({ isShowImageCode: false })} onRef={ node => this.ImageAuth = node }></ImageAuth>}
        </div>
        <div className='login-bottom'>
        </div>

      </div>
    )
  }
}

InviteLogin.propTypes = {
  title: PropTypes.string.isRequired,
  btnTitle: PropTypes.string.isRequired,
  type: PropTypes.number.isRequired,
  nextFunc: PropTypes.func.isRequired
}

export default withRouter(InviteLogin);
